import { render } from "./DisplayerPage.vue?vue&type=template&id=284d27d9&scoped=true"
import script from "./DisplayerPage.vue?vue&type=script&lang=js"
export * from "./DisplayerPage.vue?vue&type=script&lang=js"

import "./DisplayerPage.vue?vue&type=style&index=0&id=284d27d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284d27d9"]])

export default __exports__